'use client';

import { c as _c } from "react/compiler-runtime";
import { Fieldset, Heading, LayoutStack, RadioButton } from 'design-system/client';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import styles from './VotingQuestion.module.css';
import { DonationFormValues } from '@/donationForm/types';
import DonationFormField from '@/donationPages/_dependencies/components/DonationFormField';
import { useDonationFormConfig, useDonationFormContext, useDonationFormValues } from '@/donationPages/_dependencies/helpers';
import useFormErrorMessage from '@/form/ActionForm/useFormErrorMessage';
import FormCheckbox from '@/form/FormCheckbox';
function VotingQuestion() {
  const $ = _c(3);
  const {
    question
  } = useDonationFormConfig();
  if (!question) {
    return null;
  }
  const {
    options
  } = question;
  let t0;
  if ($[0] !== options || $[1] !== question) {
    t0 = <VotingQuestionContent {...question} options={options} />;
    $[0] = options;
    $[1] = question;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}
type Option = {
  id: string;
  text: string;
};
type VotingQuestionContentProps = {
  text: string;
  options: Array<Option>;
};
function VotingQuestionContent(t0) {
  const $ = _c(18);
  const {
    text,
    options
  } = t0;
  const t = useTranslations("nextjs.donate.voting");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["_voting_opt_in"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [optIn] = useDonationFormValues(t1);
  const {
    clearErrors
  } = useDonationFormContext();
  const error = useFormErrorMessage("voting_option_id");
  let t2;
  if ($[1] !== optIn) {
    t2 = () => {
      if (optIn) {
        return;
      }
    };
    $[1] = optIn;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== clearErrors || $[4] !== optIn) {
    t3 = [clearErrors, optIn];
    $[3] = clearErrors;
    $[4] = optIn;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  const t4 = optIn ? error : undefined;
  let t5;
  if ($[6] !== t) {
    t5 = t("heading");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <DonationFormField as={FormCheckbox} name="_voting_opt_in"><Heading level="heading-xs" className={styles.headingMargin}>{t5}</Heading></DonationFormField>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== optIn || $[11] !== options || $[12] !== text) {
    t7 = optIn && <><Heading level="text-md-important">{text}</Heading>{options.map(_temp)}</>;
    $[10] = optIn;
    $[11] = options;
    $[12] = text;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t6 || $[16] !== t7) {
    t8 = <LayoutStack><Fieldset className={styles.fieldset} error={t4} legend={t6} layout="vertical">{t7}</Fieldset></LayoutStack>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
function _temp(t0) {
  const {
    id,
    text: text_0
  } = t0;
  return <DonationFormField key={id} as={RadioButton} type="radio" name="voting_option_id" value={id}>{text_0}</DonationFormField>;
}
export default VotingQuestion;